import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AspectStatus, CompetencyLevel } from '@app/models/evaluation.model';

const COMPETENCY_LEVELS = {
	['Competent' as CompetencyLevel]: {
		icon: 'check_circle',
		class: 'rating-competent',
		isSvg: false,
	},
	['Approaching Competence' as CompetencyLevel]: {
		icon: 'warning',
		class: 'rating-approaching',
		variant: 'round',
		isSvg: false,
	},
	['Not Evident' as CompetencyLevel]: {
		icon: 'cancel',
		class: 'rating-not-evident',
		isSvg: false,
	},
	['pending']: {
		icon: 'progress-check',
		class: 'pending',
		variant: 'outlined',
		isSvg: true,
	},
	['Completed']: {
		icon: 'lock',
		variant: 'round',
		class: 'completed',
		isSvg: false,
	},
};

@Component({
	selector: 'app-status-icon',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './status-icon.component.html',
	styleUrls: ['./status-icon.component.scss'],
})
export class StatusIconComponent {
	@Input() value!: CompetencyLevel | undefined;
	@Input() aspectStatus!: AspectStatus;

	get competencyLevelValue() {
		if (this.aspectStatus?.name === 'Locked') {
			return 'Completed';
		}
		return this.value || 'pending';
	}

	get statusVariant() {
		return COMPETENCY_LEVELS[this.competencyLevelValue];
	}

	get materialClasses() {
		return [
			`material-icons${COMPETENCY_LEVELS[this.competencyLevelValue].variant ? '-' + COMPETENCY_LEVELS[this.competencyLevelValue].variant : ''}`,
			COMPETENCY_LEVELS[this.competencyLevelValue].class,
		].join(' ');
	}
}
